import React, { useContext } from 'react'
import { I18nextContext } from '@toasttab/shared/src/context/i18nextContext'
import { useI18next } from '@toasttab/shared/src/hooks/useI18next'
import { localizeLink } from '@toasttab/shared/src/utils/linkUtils'
import { FooterLegalLinksProps } from './Footer.d'

const FooterLegalLinks = ({ hostName, legalLinks }: FooterLegalLinksProps) => {
  const { t } = useI18next()
  const localizationContext = useContext(I18nextContext)

  const legalLinkCss =
    'text-secondary hover:text-default font-sansPro font-normal text-xs'

  const togglePrivacyModal = () => {
    // @ts-ignore
    if (typeof window !== 'undefined' && window.OneTrust) {
      // @ts-ignore
      window.OneTrust.ToggleInfoDisplay()
    }
  }

  return (
    <div
      className='ds-footer-container pt-8 pb-6'
      data-testid='FooterLegalLinks'
    >
      <ul className='flex flex-row flex-wrap items-start lg:justify-between'>
        {legalLinks.map((menu: any, i: number) => {
          return (
            <li
              key={i}
              className='mb-4 mr-4 md:mr-8 lg:mr-0 mb-0'
              data-testid='FooterLegalLinks-listItem'
            >
              {menu.text === 'Cookie Settings' && (
                <button className={legalLinkCss} onClick={togglePrivacyModal}>
                  {t(menu.text)}
                </button>
              )}
              {menu.href?.startsWith('http') && (
                <a
                  className={legalLinkCss}
                  data-testid='FooterLegalLinks-link-external'
                  href={menu.href}
                  rel='nofollow'
                >
                  {t(menu.text)}
                </a>
              )}
              {menu.href &&
                !menu.href.startsWith('http') &&
                !menu.href.startsWith('/') && (
                  <a
                    className={legalLinkCss}
                    data-testid='FooterLegalLinks-link-host'
                    href={`${hostName}/${menu.href}`}
                    rel='nofollow'
                  >
                    {t(menu.text)}
                  </a>
                )}
              {menu.href?.startsWith('/') && (
                <a
                  className={legalLinkCss}
                  data-testid='FooterLegalLinks-link-local'
                  href={localizeLink(
                    menu.href,
                    localizationContext.language,
                    localizationContext
                  )}
                >
                  {t(menu.text)}
                </a>
              )}
            </li>
          )
        })}
        <li className='text-secondary font-sansPro font-normal text-xs leading-[24px]'>
          &copy; {new Date().getFullYear()} Toast, Inc.
        </li>
      </ul>
    </div>
  )
}

export default FooterLegalLinks
